import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: "root",
})
export class LogmanagementService {
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getLogData(currentPage: number, rows: number, searchValue, selectedValue, selectedSource, selectedROA, selectedSection, selectedField, startdate, enddate, email, selectedIsLive): Observable<any> {
    const params = new HttpParams()
      .set('page_number', currentPage ? currentPage.toString() : '1')
      .set('per_page_record', rows ? rows.toString() : '50')
      .set('search_value', searchValue || '')
      .set('status', selectedValue ? selectedValue.toString() : '')
      .set('source', selectedSource ? selectedSource.toString() : '')
      .set('selectedroa', selectedROA || '')
      .set('section', selectedSection ? selectedSection.toString() : '')
      .set('field', selectedField ? selectedField.toString() : '')
      .set('start_date', startdate || '')
      .set('end_date', enddate || '')
      .set('user_email', email ? email.toString() : '')
      .set('products_filter', selectedIsLive || '');
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.LOG_DATA}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getShortageStatusLogData(currentPage: number, rows: number, searchValue, selectedValue, startdate, enddate, email): Observable<any> {
    const statusMap = {
      'PENDING': 0,
      'APPROVED': 1,
      'REJECT': 2
    };

    const params = new HttpParams()
      .set('page_number', currentPage ? currentPage.toString() : '1')
      .set('per_page_record', rows ? rows.toString() : '50')
      .set('search_value', searchValue || '')
      .set('status', statusMap[selectedValue] !== undefined ? statusMap[selectedValue].toString() : '0')
      .set('section', 'SHORTAGE')
      .set('field', 'NDA_MAPPING')
      .set('start_date', startdate || '')
      .set('end_date', enddate || '')
      .set('user_email', email ? email.toString() : '');

    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.LMS_SHORTAGE_STATUS}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateShortageStatus(data: any): Observable<any> {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.LMS_SHORTAGE_STATUS}`, data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getDSAndaDR(uniqnumber, user_ip, approve_reject_by, approved, selectedOption): Observable<any> {
    const params = new HttpParams()
      .set('unique_number', uniqnumber)
      .set('ip_addess', user_ip)
      .set('approve_reject_by', approve_reject_by)
      .set('approved', approved)
      .set('selected_option', selectedOption || '');

    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.DS_ANDA_DR}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getDSTime(): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.LMS_DS_TIME}`
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getUniqueRoa(): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.UNIQUE_ROA}`
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getLMSNotes(): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.LMS_NOTES}`
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getNdaSaleData(): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.GET_SALE_VOL_COM}?user_email=${localStorage.getItem('email') || ''}`
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  postNdaSaleDatatAPI(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.GET_SALE_VOL_COM}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getScreenshotsAPI(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.LOG_MANAGEMENT.GET_LCM_SCREENSHOTS}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
